import { type AccountResponse, AccountType } from '@shared/api/rest/accounts';
import { AccountCardSmallTile } from './small/card';
import { AccountPaymentSmallTile } from './small/payment';

interface AccountTileBigProps {
  account: AccountResponse;
  mainAccount?: AccountResponse;
  subAccounts: AccountResponse[];
  selectedAccountId?: number;
  onAccountSwitch: (accountId: number) => void;
}

export const AccountTileBig = (props: AccountTileBigProps) => {
  if (props.account.type === AccountType.Payment)
    return (
      <AccountPaymentSmallTile
        account={props.account}
        mainAccount={props.mainAccount}
        subAccounts={props.subAccounts}
        selectedAccountId={props.selectedAccountId}
        onAccountSwitch={props.onAccountSwitch}
      />
    );
  else if (props.account.type === AccountType.Card) return <AccountCardSmallTile account={props.account} />;
  return null;
};
